import React, { useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";


export default function Gurgaon_plant() {

  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content">
                        <h2>Gurgaon Plant</h2>

                        <div class="row">
                          <div class="col-sm-6">
                            <img
                              src="../images/gurgaon-plant.jpg"
                              class="img-responsive"
                            />
                          </div>
                          <div class="col-sm-6">
                            <div class="address">
                              <ul>
                                <li>
                                  <img src="../images/person.png" />{" "}
                                  <span>Contact Person Name : </span> Shri
                                  Sanjay Kumar
                                </li>
                                <li>
                                  <img src="../images/desi.png" />{" "}
                                  <span>Designation : </span>General Manager
                                </li>
                                <li>
                                  <img src="../images/home-icon.png" />{" "}
                                  <span>Address : </span> Dundahera,
                                  Gurgaon-122016, (Haryana)
                                </li>
                                <li>
                                  <img src="../images/cell_icon.gif" />{" "}
                                  <span>Telephone : </span>0124-2455519,
                                  9868327477
                                </li>

                                <li>
                                  <img src="../images/fax.png" />
                                  <span> Fax No. : </span> 0124-2456021, 2340612
                                </li>
                                <li>
                                  <img src="../images/mouse_icon.gif" />{" "}
                                  <span>E-mail : </span>
                                  s.kumaridpl@gmail.com
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <br />

                        <p>
                          The Gurgaon Plant is located on old Delhi – Gurgaon
                          road , 6 kms from Indira Gandhi International Airport
                          , Delhi, in Haryana State at 90 acres of land (0.36
                          million sq. mts ). Out of this the plant is setup in
                          approx 65 acres of land.
                        </p>
                        <p>
                          The plant, commissioned in 1979 , has production
                          capacities for wide range of formulations like tablets
                          (1296 million nos.) , liquid orals (396 kilo liters)
                          and dry syrup (36 lakh bottles). This plant is also
                          having large capacity to manufacture Oral
                          Contraceptive Pills. ( OCP ) and has been a regular
                          supplier of Oral Contraceptive Pills to Ministry of
                          Health & Family Welfare over more than last twenty
                          years.
                        </p>
                        <p>
                          These production facilities are fully supported by
                          good Quality Control Department. It has an Effluent
                          Treatment Plant (ETP) and a Formulations Development
                          Research Laboratory. There is also a township with 128
                          flats having other facilities.
                        </p>
                        <br />

                        <div class="clearfix"></div>

                        <div class="">
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1753.0175609456555!2d77.07099719104038!3d28.508591011532115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d197196b1f0b3%3A0x577f5095080f0465!2sIndian+Drugs+And+Pharmaceuticals+Ltd!5e0!3m2!1sen!2sin!4v1450344238493"
                            width="100%"
                            height="250"
                            frameborder="0"
                            style={{ border: "0;" }}
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
